<template>
  <div class="logInComponent">
    <div class="logInContainer">
      <div class="logInCard">
        <div class="logoContainer">
          <img alt="ACG logo" class="logo" src="@/assets/img/logoblack.svg" />
        </div>
        <validation-observer  v-slot="{ handleSubmit }" tag="div">
          <form @submit.prevent="handleSubmit(formSubmit)"  class="form form--login" >
            <h4 style="text-align: center">Request new password</h4>
            <p style="text-align: center">Type your new password two times, and click on "reset password" button</p>
            <div class="inputContainer">
              <div>
                <ValidationProvider :rules="{required: true, regex: /^(?=.*(?:\d|[^\dA-Za-z]))(?=.*[A-Z]).*$/}" vid="userPassword"  v-slot="{ errors }">
                  <div class="form-row">
                    <input class="emailInput" placeholder="Password" name="E-mail" type="password" v-model="loginForm.password" />
                    <div class="form__error">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
                <ValidationProvider :rules="{required: true, confirmed:'userPassword'}" v-slot="{ errors }">
                  <div class="form-row">
                    <input class="emailInput"  data-vv-as="password" placeholder="Password Confirmation" name="E-mail" type="password" v-model="loginForm.passconf" />
                    <div class="form__error">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
                
                <div>
                  <router-link class="text-link" :to="{name: 'LogIn'}">Back to Login</router-link>
                </div>
              </div>
              <div class="error--s" style="font-size:12px; color: red; margin-bottom: 10px;" v-if="error.length > 0">{{error}}</div>
              <div class="error--s" style="font-size:12px; color: green; margin-bottom: 10px;" v-if="success.length > 0">{{success}}</div>
              <button type="submit" class="btn btn-green logInButton">Reset Password</button>
            </div>
          </form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend  } from 'vee-validate';
import {confirmed, regex, required} from 'vee-validate/dist/rules';
import { setInteractionMode } from 'vee-validate';

setInteractionMode('eager');
extend('required', {
  ...required,
  message: "{_field_} is required."
});
extend('regex', {
  ...regex,
  message: "Your password must contain at least one uppercase letter, and one number or special character"
});
extend("confirmed", {
  ...confirmed,
  message: "Not the same password",
});

export default {  
  data(){
    return{
      loginForm:{
        passconf: null,
        password: null
       
      },
      error: "",
      success: ""
    }
  },
  components:{
    ValidationProvider,
    ValidationObserver        
  },
  created(){
    
  },
  methods:{
    formSubmit(){
        let _this = this

        _this.post('forgottenpassword/changepassword',
          {
            forgotten_token: _this.$route.params.token,
            password: _this.loginForm.password,
            passconf: _this.loginForm.passconf
          },
          {},function () {
           _this.$router.push({name:'Login'})
            location.reload();
          },function(){
            //error
            //console.log('login error:', error.data)
            
            
              _this.error = 'Your passwords are not matching or your token is expired...'
            }
          
        )
    }
  }
}
</script>